import styled from 'styled-components';
import { Toggle, TOGGLE_SIZES } from 'ui/toggle';
import { colors, fontSizes, fontWeights, spacing } from 'ui/theme';

import { MESSAGE_MEDIUM_DISPLAY_NAMES } from '../../constants';
import { useModalsContext } from '../../contexts';
import { ExtendedChannel } from '../../types';

const displayText = {
  subscribed: 'Subscribed',
  unsubscribed: 'Unsubscribed',
  id: 'ID',
};

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  padding: ${spacing.plusHalf} ${spacing.double};
`;

const Name = styled.div`
  color: ${colors.textPrimary};
  font-size: ${fontSizes.s20};
  margin-right: ${spacing.half};
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

const Details = styled.div`
  display: flex;
  column-gap: ${({ theme }) => theme.spacing.values.quarter};
  color: ${colors.textSecondary};
  font-size: ${fontSizes.s12};
  flex-grow: 1;
  margin: ${spacing.eighth} ${spacing.half} 0 0;
  white-space: nowrap;
`;

const Status = styled.label`
  color: ${colors.textSecondary};
  font-size: ${fontSizes.s14};
  margin: 0 ${spacing.half} 0 0;
  font-weight: ${fontWeights.regular};
`;

const Dot = styled.span`
  font-size: smaller;
  color: ${colors.grey35};
`;

type TitleProps = {
  channel: ExtendedChannel;
};

export const Title = ({ channel }: TitleProps) => {
  const { showModal } = useModalsContext();
  const handleToggleClick = () => {
    showModal(
      channel.isSubscribed
        ? { unsubscribingFromChannels: [channel] }
        : { subscribingToChannels: [channel] },
    );
  };
  const statusId = `subscription-status--channel-${channel.id}`;
  return (
    <Wrapper>
      <Name title={channel.name}>{channel.name}</Name>
      <Details>
        <span>
          {displayText.id}: {channel.id}
        </span>
        <Dot>•</Dot>
        <span>{channel.channelType}</span>
        <Dot>•</Dot>
        {MESSAGE_MEDIUM_DISPLAY_NAMES[channel.messageMedium]}
      </Details>
      <Status id={statusId}>
        {channel.isSubscribed ? displayText.subscribed : displayText.unsubscribed}
      </Status>
      <Toggle
        size={TOGGLE_SIZES.SMALL}
        onClick={handleToggleClick}
        isActive={channel.isSubscribed}
        labelId={statusId}
        data-test="status-toggle"
      />
    </Wrapper>
  );
};
